export interface BrazilianBank {
  code: string;
  name: string;
}

/**
 * Catálogo conservador das instituições mais usadas no cadastro de fornecedores.
 * O código COMPE é persistido separadamente do nome exibido.
 */
export const BRAZILIAN_BANKS: readonly BrazilianBank[] = [
  { code: '001', name: 'Banco do Brasil' },
  { code: '033', name: 'Banco Santander' },
  { code: '077', name: 'Banco Inter' },
  { code: '104', name: 'Caixa Econômica Federal' },
  { code: '208', name: 'BTG Pactual' },
  { code: '212', name: 'Banco Original' },
  { code: '237', name: 'Bradesco' },
  { code: '260', name: 'Nubank' },
  { code: '336', name: 'C6 Bank' },
  { code: '341', name: 'Itaú Unibanco' },
  { code: '389', name: 'Banco Mercantil do Brasil' },
  { code: '422', name: 'Banco Safra' },
  { code: '655', name: 'Banco Votorantim' },
  { code: '748', name: 'Sicredi' },
  { code: '756', name: 'Sicoob' },
] as const;

export const bankByCode = (code?: string | null) =>
  BRAZILIAN_BANKS.find((bank) => bank.code === code);
